import { useCallback, useMemo } from "react";

import { useLengthConversion } from "./useUnitConversion";

/**
 * Hook for converting radius values between meters and user's preferred units
 * @returns Object with conversion utilities for radius display and input
 */
export default function useRadiusConverter() {
  const { convert, convertBack, getDisplayUnit, isReady } = useLengthConversion();

  const displayLabel = useMemo(() => getDisplayUnit(), [getDisplayUnit]);

  /**
   * Convert meters to display units (m or ft based on user preference)
   */
  const metersToDisplay = useCallback(
    (meters: number): number => {
      if (!isReady || !meters) {
        return meters;
      }
      return convert(meters, 2);
    },
    [isReady, convert]
  );

  /**
   * Convert display units (m or ft) back to meters
   */
  const displayToMeters = useCallback(
    (displayValue: number): number => {
      if (!isReady || !displayValue) {
        return displayValue;
      }
      return convertBack(displayValue, 2);
    },
    [isReady, convertBack]
  );

  return {
    displayLabel,
    metersToDisplay,
    displayToMeters,
    isReady
  };
}
